"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobRunner = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const UI_1 = require("../util/UI");
const AdminView_1 = require("./AdminView");
class JobRunner {
    constructor(remote) {
        this.jobIds = {};
        this.jobTimers = {};
        this.originalLabels = {};
        this.jobsStartedHere = {};
        this.remote = remote;
    }
    init(section) {
        return __awaiter(this, void 0, void 0, function* () {
            this.wire(section);
            try {
                yield this.refresh(section);
            }
            catch (err) {
                Log_1.default.warn("JobRunner::init( " + section.kind + " ) - ERROR: " + err.message);
            }
        });
    }
    wire(section) {
        const button = document.querySelector("#" + section.buttonId);
        if (button === null) {
            return;
        }
        button.onclick = (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            this.start(section).catch((err) => {
                Log_1.default.error("JobRunner::wire( " + section.kind + " ) - start ERROR: " + err.message);
            });
        };
        if (typeof section.cancelButtonId === "string") {
            const cancelButton = document.querySelector("#" + section.cancelButtonId);
            if (cancelButton !== null) {
                cancelButton.onclick = (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.cancel(section).catch((err) => {
                        Log_1.default.error("JobRunner::wire( " + section.kind + " ) - cancel ERROR: " + err.message);
                    });
                };
            }
        }
    }
    start(section) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("JobRunner::start( " + section.kind + " ) - start");
            if (this.isRunning(section)) {
                UI_1.UI.notificationToast("This job is already running (started by this page or another admin). It will finish on its own; " +
                    "its result reflects the course as it was when it started, so run it again afterwards if things have changed.", 8000);
                return;
            }
            let params = {};
            if (typeof section.params === "function") {
                params = section.params();
                if (params === null) {
                    return;
                }
            }
            const options = AdminView_1.AdminView.getOptions();
            options.method = "post";
            options.body = JSON.stringify(params);
            const response = yield fetch(this.remote + "/portal/admin/job/" + section.kind, options);
            const json = yield response.json();
            if (typeof json.success === "undefined") {
                UI_1.UI.showError(json);
                return;
            }
            this.jobIds[section.kind] = json.success.id;
            this.jobsStartedHere[section.kind] = true;
            this.setStatus(section, "Starting...");
            this.poll(section);
        });
    }
    cancel(section) {
        return __awaiter(this, void 0, void 0, function* () {
            const jobId = this.jobIds[section.kind];
            if (typeof jobId !== "string") {
                return;
            }
            if (typeof section.confirmCancel === "string" && confirm(section.confirmCancel) === false) {
                return;
            }
            Log_1.default.info("JobRunner::cancel( " + section.kind + " ) - cancelling: " + jobId);
            const options = AdminView_1.AdminView.getOptions();
            options.method = "delete";
            yield fetch(this.remote + "/portal/admin/job/" + jobId, options);
            this.setStatus(section, "Cancelling; finishing the current item...");
        });
    }
    poll(section) {
        if (typeof this.jobTimers[section.kind] !== "undefined") {
            clearInterval(this.jobTimers[section.kind]);
        }
        this.jobTimers[section.kind] = setInterval(() => {
            this.refresh(section).catch((err) => {
                Log_1.default.warn("JobRunner::poll( " + section.kind + " ) - ERROR: " + err.message);
            });
        }, 2000);
    }
    refresh(section) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const jobId = this.jobIds[section.kind];
            const url = typeof jobId === "string" ? this.remote + "/portal/admin/job/" + jobId : this.remote + "/portal/admin/jobs?kind=" + section.kind;
            const response = yield fetch(url, AdminView_1.AdminView.getOptions());
            const json = yield response.json();
            if (typeof json.success === "undefined") {
                return;
            }
            const job = Array.isArray(json.success) ? json.success[0] : json.success;
            if (typeof job === "undefined" || job === null) {
                this.setRunningLabel(section, false);
                this.setStatus(section, (_a = section.neverRun) !== null && _a !== void 0 ? _a : "Never run.");
                return;
            }
            this.jobIds[section.kind] = job.id;
            const running = job.state === "RUNNING";
            this.setRunningLabel(section, running);
            if (typeof section.cancelButtonId === "string") {
                const cancelButton = document.querySelector("#" + section.cancelButtonId);
                if (cancelButton !== null) {
                    cancelButton.style.display = running ? "" : "none";
                }
            }
            if (running === true && typeof this.jobTimers[section.kind] === "undefined") {
                Log_1.default.info("JobRunner::refresh( " + section.kind + " ) - adopting running job: " + job.id);
                this.poll(section);
            }
            if (running === false && typeof this.jobTimers[section.kind] !== "undefined") {
                clearInterval(this.jobTimers[section.kind]);
                delete this.jobTimers[section.kind];
                if (this.jobsStartedHere[section.kind] === true) {
                    delete this.jobsStartedHere[section.kind];
                    if (job.state === "SUCCEEDED" && job.summary !== null && typeof section.onFinished === "function") {
                        section.onFinished(job.summary);
                    }
                    else if (job.state !== "SUCCEEDED") {
                        UI_1.UI.showAlert(JobRunner.describeFailure(job));
                    }
                }
                if (typeof section.onTerminal === "function") {
                    section.onTerminal(job);
                }
            }
            this.setStatus(section, JobRunner.describe(job, section));
        });
    }
    setRunningLabel(section, running) {
        const button = document.querySelector("#" + section.buttonId);
        if (button === null) {
            return;
        }
        if (typeof this.originalLabels[section.kind] !== "string") {
            this.originalLabels[section.kind] = button.innerText.trim();
        }
        const label = running ? "Running\u2026" : this.originalLabels[section.kind];
        if (button.innerText.trim() !== label) {
            button.innerText = label;
        }
    }
    isRunning(section) {
        return typeof this.jobTimers[section.kind] !== "undefined";
    }
    static describe(job, section) {
        var _a;
        var _b, _c, _d;
        const when = (_c = (_b = job.completedAt) !== null && _b !== void 0 ? _b : job.startedAt) !== null && _c !== void 0 ? _c : job.createdAt;
        const stamp = new Date(when).toLocaleString();
        if (job.state === "RUNNING") {
            const progress = (_d = job.progress) !== null && _d !== void 0 ? _d : { done: 0, total: 0, message: "" };
            const counts = progress.total > 0 ? progress.done + " of " + progress.total : "";
            const message = progress.message ? (counts === "" ? "" : " ") + "(" + progress.message + ")" : "";
            return JobRunner.twoLines("Running since " + stamp + ".", counts + message);
        }
        let detail = "";
        if (job.summary !== null && typeof job.summary !== "undefined") {
            detail = section.detail(job.summary);
        }
        if (((_a = job.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (detail !== "") {
                detail += " ";
            }
            detail += "<b>" + job.errors[0] + "</b>";
            if (job.errors.length > 1) {
                detail += " (and " + (job.errors.length - 1) + " more)";
            }
        }
        return JobRunner.twoLines(section.ran + " " + stamp + " (" + job.state.toLowerCase() + ").", detail);
    }
    static twoLines(first, second) {
        if (second === "") {
            return "<div>" + first + "</div>";
        }
        return "<div>" + first + "</div><div>" + second + "</div>";
    }
    static describeFailure(job) {
        var _a;
        if (((_a = job.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return job.errors[0];
        }
        return "Job " + job.state.toLowerCase() + ".";
    }
    setStatus(section, html) {
        const el = document.querySelector("#" + section.statusId);
        if (el !== null) {
            el.innerHTML = html;
        }
    }
}
exports.JobRunner = JobRunner;
